import { render, staticRenderFns } from "./course-stats.vue?vue&type=template&id=1c704e05&scoped=true"
import script from "./course-stats.vue?vue&type=script&lang=js"
export * from "./course-stats.vue?vue&type=script&lang=js"
import style0 from "./course-stats.vue?vue&type=style&index=0&id=1c704e05&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c704e05",
  null
  
)

export default component.exports